/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { isMobile } from '../../components/breakpoints';

import { IEcommMobileStreamBannerViewProps } from './ecomm-mobile-stream-banner';
import { textAlignment } from './ecomm-mobile-stream-banner.props.autogenerated';

export class MobileStreamBannerView extends React.PureComponent<IEcommMobileStreamBannerViewProps> {
  public state: any = {  width: 0, hasMounted: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      window.addEventListener('resize', this._updateDimensions);

      this.setState({ width: window.innerWidth, hasMounted: true });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    if (isMobile(this.state.width)) {
      const { config } = this.props;

      const bg = config.bannerImage?.src ? { backgroundImage: `url(${config.bannerImage.src})` } : { backgroundImage: '' };

      if (config.textAlignment === textAlignment.right) {
        return (
          <div className='ecomm-mobile-stream-banner right' style={bg} onClick={this._onClick}>
            <h4>{config.caption}</h4>
            <h1>{config.bannerTitle}</h1>
          </div>
        );
      }
  
      return (
        <div className='ecomm-mobile-stream-banner' style={bg} onClick={this._onClick}>
          <h5 className='caption'>{config.caption}</h5>
          <h3>{config.bannerTitle}</h3>
        </div>
      );
    }

    return null;
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  private _onClick = () => {
    const { config } = this.props;

    if (typeof window !== 'undefined') {
      window.location.assign(config.mobilePage.destinationUrl);
    }
  }

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };
}

export default MobileStreamBannerView;
